<template>
  <default-modal ref="box" :title="title" :modalWidth="600" :confirmTxt="confirmText" @confirm="confirm">
    <div class="modal-body">
      <div class="tips">
        <div>
          请选择需要使用“
          <span style="color:#D9001B;" v-text="ruleName"></span>
          ”规则的安全中心网吧分组（该分组与维护大师远程功能分组相互独立，互不影响）。
        </div>
        <div>
          规则应用完成后，在对应分组的网吧客户机，重启后自动生效。
        </div>
      </div>
      <div class="table">
        <div style="padding-bottom: 10px;">
          选择安全组类别：<Select v-model="secGroupTypeId" placeholder="请选择安全组类别" slot="prepend" style="width: 300px">
            <Option value="0">全部安全组</Option>
            <Option v-for="(item,index) in secGroupTypeData" :key="index" :value="item.id">{{ item.securityTypeName }}</Option>
          </Select>
        </div>
        <div class="table-header row">
          <div>
            <input type="checkbox" v-model="isSelectAll" @change="selectAllChange" />
          </div>
          <div>
            安全组名称
          </div>
          <div>
            安全组分类
          </div>
          <div>
            已应用规则
          </div>
        </div>
        <div class="table-body" >
          <div class="row" v-for="(item, index) in tableList" :key="index">
            <!-- 选中 -->
            <div>
              <input type="checkbox" @click.stop v-model="item.select" @change="selectChange(item.select)" />
            </div>
            <!-- 安全组名称 -->
            <div>
              <span v-text="item.securityName"></span>
            </div>
            <!-- 安全组分类名称 -->
            <div>
              <span v-text="item.securityTypeName"></span>
            </div>
            <!-- 组内规则数 -->
            <div>
              <span v-text="item.ruleNum"></span>
            </div>
          </div>
          <no-data style="height:auto;padding-top:20px;padding-bottom:20px;" v-show="tableList.length == 0 || loading"
            :nodata="tableList.length == 0 && !loading" :loading="loading"></no-data>
        </div>
      </div>
      <div class="toHref">
        <!-- <a href="#" @click="toHref">需要添加或修改安全组？</a> -->
        <span v-text="wrong" style="color:tomato;margin-left:5px;"></span>
      </div>
    </div>
  </default-modal>
</template>
<script>
import DefaultModal from '_c/modals/defaultModal'
import NoData from '_c/noData/noData'
import { applySecurityGroup } from '@/requests/securityCenter'
import { mapState, mapActions } from 'vuex'
import {secGroupTypeList, listSecurityGroup} from '@/requests/secGroup'
export default {
  components: {
    DefaultModal,
    NoData,
  },
  data () {
    return {
      ruleId: '',
      ruleName: '',
      applySecurityGroup: '',
      title: '应用到安全组',
      confirmText: '确定',
      successFn: '',
      tableList: '',
      loading: false,
      isSelectAll: false,
      wrong: '',
      secGroupTypeId: '0',
      secGroupTypeData: []
    }
  },
  watch: {
    secGroupTypeId() {
      this.listSecurityGroup()
      setTimeout(() => {
        this.init()
      }, 10);
    }
  },
  computed: {
    // ...mapState({
    //   allSecurityGroup: (state) => state.securityCenter.allSecurityGroup,
    // }),
  },
  mounted () {
    this.secGroupTypeList()
    this.listSecurityGroup()
    window.$modal.applySafetyRule = {}
    window.$modal.applySafetyRule.show = (
      ruleName,
      id,
      applySecurityGroup
    ) => {
      this.ruleName = ruleName
      this.ruleId = id
      this.applySecurityGroup = applySecurityGroup
      // this.tableList = this.allSecurityGroup.map((item) => {
      //   item.select = false
      //   return item
      // })
      return new Promise((resolve) => {
        this.init(() => {
          resolve(true)
        })
      })
    }
  },
  methods: {
    async listSecurityGroup() {
      let secGroupTypeId = ''
      if (this.secGroupTypeId != 0) {
        secGroupTypeId = this.secGroupTypeId
      }
      let res = await listSecurityGroup({
        groupTypeId: secGroupTypeId
      })
      if (res.code == 200) {
        this.tableList = res.data
      }
    },
    async secGroupTypeList() {
      let res = await secGroupTypeList()
      if (res.code == 200) {
        this.secGroupTypeData = res.data
      }
    },
    ...mapActions(['securityCenter/actionSetSecurityInfo']),
    // 初始化信息
    init (fn) {
      this.wrong = ''
      this.$refs.box.show()
      this.isSelectAll = false
      if (this.applySecurityGroup) {
        this.isSelectAll =
          this.applySecurityGroup.split(',').length == this.tableList.length
        this.tableList.forEach((item) => {
          for (let it of this.applySecurityGroup.split(',')) {
            if (Number(it) == item.id) {
              item.select = true
            }
          }
          return item
        })
      }
      this.successFn = fn
    },
    selectAllChange () {
      if (this.isSelectAll) {
        this.tableList.forEach((item) => {
          item.select = true
        })
      } else {
        this.tableList.forEach((item) => {
          item.select = false
        })
      }
    },
    selectChange (selectState) {
      if (selectState) {
        // 对单项进行选中
        // 判断是否全部选中
        let selectAllState = this.tableList.every((item) => {
          return item.select == true
        })
        // 若全部选中,则为全选状态
        if (selectAllState) {
          this.isSelectAll = true
        }
      } else {
        // 对单项进行取消
        this.isSelectAll = false
      }
    },
    selectedIds () {
      let arr = []
      this.tableList.forEach((item) => {
        if (item.select) {
          arr.push(item.id)
        }
      })
      return arr
    },
    async confirm () {
      // if (this.selectedIds().length == 0) {
      //     this.wrong = "请选择安全组";
      //     return false;
      // }
      let resValue = await applySecurityGroup({
        id: this.ruleId,
        securityGroupId: this.selectedIds().join(','),
      })
      if (resValue.code == 200) {
        await this['securityCenter/actionSetSecurityInfo']()
        this.$refs.box.hide()
        // this.successFn()
      } else {
        this.wrong = resValue.msg
        return false
      }
    },
    toHref () {
      this.$router.push({
        path: this.$PAGE_API.home.children.securityCenter.children.index
          .children.barManageSecurityGroup.path,
        query: {
          val: 1,
        },
      })
      this.$refs.box.hide()
    },
  },
}
</script>
<style lang="scss" scoped>
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";

.modal-body {
  padding: 10px 20px;
  text-align: left;
  position: relative;

  .tips {
    border: 1px solid rgba(215, 215, 215, 1);
    background: rgb(219, 219, 219);
    padding: 3px;
    margin-bottom: 15px;
  }

  .table {
    max-height: 382px;
    overflow-y: auto;

    .row {
      width: 100%;
      cursor: pointer;
      @include clearfix();

      &:after {
        content: "";
        top: 0;
        left: 0;
        display: block;
        font-size: 0;
        height: 0;
        width: 0;
        clear: both;
        visibility: hidden;
      }

      >div {
        float: left;
        text-align: left;
        text-overflow: ellipsis;
        height: 50px;

        span {
          @include ellipsis();
          max-width: 100%;
        }

        p {
          @include ellipsis();
          max-width: 100%;
        }

        a {
          text-align: left;
          text-indent: 0px;
          margin-right: 8px;
          color: #02a7f0;
        }

        input {
          cursor: pointer;
        }
      }

      >div:nth-child(1) {
        width: 5%;
        text-indent: 10px;

        input {
          position: relative;
          top: 2px;
        }
      }

      >div:nth-child(2) {
        width: 45%;
        text-align: left;
      }

      >div:nth-child(3) {
        width: 25%;
        text-align: center;
      }

      >div:nth-child(4) {
        width: 25%;
        text-align: center;
      }
    }

    .table-header {
      >div {
        height: 30px;
        line-height: 30px;
      }
    }
  }

  .toHref {
    position: absolute;
    bottom: -43px;
  }
}
</style>
